import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import flatpickr from 'flatpickr';
import { German } from 'flatpickr/dist/l10n/de';
import { getClassName, renderValidationIcon } from '../../../utils/InputValidation';
import FieldValidationMessage from '../FieldValidationMessage'
import Label from '../Label/Label';
import style from '../Fields.scss';
import 'flatpickr/dist/flatpickr.min.css';
import './DatePicker.scss';
import LoaderButton from '../../LoaderButton/LoaderButton';
import { compose } from 'redux';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';
class DatePicker extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      easyTransportDescritption: props.customerComment,
    };
  }

  componentWillUnmount() {
    if (this.datepickerInstance) this.datepickerInstance.destroy();
  }

  setDatePickerRef = (ref) => {
    if (!this.datepickerRef && ref) {
      const { onChange } = this.props;
      this.datepickerInstance = flatpickr(ref, {
        dateFormat: 'd.m.Y',
        onChange,
        minDate: Date.now(),
        locale: German,
        inline: true,
      });
    }
  }
  render() {
    const {
      optional,
      placeholder,
      hideMessages,
      input,
      name,
      label,
      pickupLabel,
      type,
      onChange,
      meta: {
        touched,
        error,
        warning,
        invalid,
        visited,
      },
      handlePickupDateSubmit,
      handleSetTransferredForTransportSubmit,
      isLoading,
      isEasyTransportOn,
      sendDateToSellerLabel,
      cancelLabel,
      sendLabel,
      disabled,
      t,
    } = this.props;
    const shouldShowErrors = error && !hideMessages;
    const shouldShowWarnings = warning && !hideMessages;
    return (
      <div>
        <div
          id="easy-transport-modal"
          className="modal fade date-picker-modal"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                ><i className="fa fa-times" /></button>
                <h4 className="modal-title">{sendDateToSellerLabel}</h4>
              </div>
              <div className="modal-body text-center">
                {isEasyTransportOn &&
                  <h4 className="modal-title">
                    {t('easy_transport')}
                  </h4>
                }
              </div>
              <div
                className="input-wrapper"
                style={{ padding: '0em 1em' }}
              >
                <input
                  value={this.state.easyTransportDescritption}
                  className="settings_input"
                  onChange={e => this.setState({ easyTransportDescritption: e.target.value })}
                  placeholder={t('easy_transport_description')}
                />
              </div>
              <div className="modal-footer">
                <button
                  id="cancel-button"
                  data-dismiss="modal"
                  className="labels labels__right cancel-button"
                >{cancelLabel}
                </button>
                <LoaderButton
                  disabled={disabled}
                  label={sendLabel}
                  onClick={() => handleSetTransferredForTransportSubmit(this.state.easyTransportDescritption)}
                  className="submit-button labels labels__right"
                  isLoading={isLoading}
                  dataDismiss="modal"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          id="date-picker-modal"
          className="modal fade date-picker-modal"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                ><i className="fa fa-times" /></button>
                <h4 className="modal-title">{pickupLabel}</h4>
              </div>
              <div className="modal-body text-center">
                <div className="input-wrapper date-picker">
                  {label && <Label optional={optional} name={name} label={label} />}
                  <input
                    {...input}
                    onChange={onChange}
                    ref={this.setDatePickerRef}
                    placeholder={placeholder}
                    type={type}
                    className={getClassName(touched, invalid, visited)}
                  />
                  {renderValidationIcon(touched, invalid, visited)}
                  {touched && (
                    (shouldShowErrors &&
                      <strong className="text-error error"><FieldValidationMessage message={error} /></strong>) ||
                    (shouldShowWarnings &&
                      <strong className="text-error warning"><FieldValidationMessage message={warning} /></strong>
                    )
                  )}
                  <style jsx="true">{`
                .input__wrapper {
                  margin-bottom: 20px;
                }
                .labels__left span {
                  margin-left: auto !important;
                }
              `}</style>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  id="cancel-button"
                  data-dismiss="modal"
                  className="labels labels__right cancel-button"
                >{cancelLabel}
                </button>
                <LoaderButton
                  disabled={disabled}
                  label={sendLabel}
                  onClick={handlePickupDateSubmit}
                  className="submit-button labels labels__right"
                  isLoading={isLoading}
                  dataDismiss="modal"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DatePicker.propTypes = {
  type: PropTypes.string,
  customerComment: PropTypes.string,
  t: PropTypes.func.isRequired,
  input: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  optional: PropTypes.bool,
  placeholder: PropTypes.string,
  hideMessages: PropTypes.bool,
  onChange: PropTypes.func,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]),
  }),
  cancelLabel: PropTypes.string,
  sendLabel: PropTypes.string,
  easyTransport: PropTypes.string,
  pickupLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  handlePickupDateSubmit: PropTypes.func,
  handleSetTransferredForTransportSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  isEasyTransportOn: PropTypes.bool,
  sendDateToSellerLabel: PropTypes.string,
  disabled: PropTypes.bool,
};

DatePicker.defaultProps = {
  input: {},
  customerComment: '',
  type: null,
  label: '',
  name: '',
  hideMessages: false,
  optional: false,
  placeholder: undefined,
  onChange: null,
  meta: {},
  cancelLabel: '',
  sendLabel: '',
  easyTransport: '',
  pickupLabel: undefined,
  handlePickupDateSubmit: null,
  handleSetTransferredForTransportSubmit: null,
  isLoading: false,
  isEasyTransportOn: false,
  sendDateToSellerLabel: '',
  disabled: false,
};

const mapStateToProps = (state) => {
  return {
    customerComment: get(state, ['offerDetails', 'data', 'contract', 'customer_comment']),
  };
};

export default compose(connect(mapStateToProps), withScopedTranslations('details_date_bar'))(DatePicker);
